"use client"

import { FactoryHeader, HeaderVariants } from "@/components/layout"
import { Translate } from "@/components/translate"
import { getChannelFromSiteIdString } from "@/config/channel"
import { useSearchParams } from "next/navigation"
import { useEffect } from "react"
import { CallUs } from "./components/error/call-us"
import { ChatIn } from "./components/error/chat-in"

type ErrorProps = {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error({ error }: ErrorProps) {
  const searchParams = useSearchParams()

  useEffect(() => {
    console.log(error)
  }, [error])

  return (
    <>
      <FactoryHeader
        variant={HeaderVariants.base}
        siteid={getChannelFromSiteIdString(searchParams.get("siteid"))}
      />

      <div className="errorPage">
        <div className="error-bg h-[25vw] min-h-44 bg-[url('/loginJwt/assets/error-page/bg.svg')] bg-cover bg-top bg-no-repeat text-primary">
          <div className="lifebelt h-full bg-[url('/loginJwt/assets/error-page/lifebelt.svg')] bg-[length:200px] bg-[70%_bottom] bg-no-repeat md:bg-[length:250px] lg:bg-[length:350px]"></div>
        </div>
        <div className="container mx-auto px-5">
          <div className="header-form">
            <h2 className="sub-title-form font-secondary text-title-xl font-extrabold">
              <Translate i18nKey="ErrorPage.somethingWentWrong" />
            </h2>
            <p className="label-form mt-1 text-title-xxs md:text-title-xs">
              <Translate i18nKey={"ErrorPage.baseText"} />
            </p>
          </div>
          <div className="mt-8 md:px-4">
            <div className="flex flex-wrap">
              <CallUs />
              <ChatIn />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
